import React from 'react'

import Image from 'next/image'

import { AppearingWrapper } from 'Components/Blocks'

import { BackgroundImageHolder, Container } from './styles'

import { MembershipPointsItem } from '../constants'

const BACKGROUND_SIZES = [270, 270, 300, 400, 400, 480]

type Props = {
  item?: MembershipPointsItem
}

function WhyChooseEmajinGolPointMediaHolder({ item }: Props) {
  if (!item) return null

  return (
    <Container height={[400, 400, 500]} width={[1, 1, 1, 1, 1 / 2]}>
      <BackgroundImageHolder height={BACKGROUND_SIZES} width={BACKGROUND_SIZES}>
        <AppearingWrapper centered kind="expand">
          <Image
            alt={item.backgroundImageAlt}
            height={item.backgroundImage.height}
            src={item.backgroundImage}
            width={item.backgroundImage.width}
          />
        </AppearingWrapper>
      </BackgroundImageHolder>
    </Container>
  )
}

export default WhyChooseEmajinGolPointMediaHolder
